// $('.c-button').on("mouseenter", function(){
//     gsap.fromTo($(this).find('.c-button-line'), 
//         { width: '0px', }, 
//         { width: "100%", duration: 1, ease: "power2.out" }
//     );
// });

// // $('.c-button').on("mouseleave",  function(){
// //     gsap.to($(this).find('.c-button-line'), 
// //         { width: "0px", duration: 0.5, ease: "power2.out"  }
// //     );
// // });

// $('.c-button').on("click", function(){
//     gsap.fromTo($(this).find('.c-button-line'), 
//         { width: '0px', }, 
//         { width: "100%", duration: 1, ease: "power2.out" }
//     );
// });

class collectionTab extends HTMLElement {
    constructor() {
        super();
        new Swiper(this, {
            slidesPerView: "auto",
            spaceBetween: 20
        });
    }

    //   // Method to execute when the button is clicked
    //   handleClick() {
    //     alert('Button clicked!');
    //   }
}

// Define the custom element
customElements.define('collection-tab', collectionTab);


class collectionFilter extends HTMLElement {
    constructor() {
        super();

        // 绑定方法
        this.updateSort = this.updateSort.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.fillActiveState = this.fillActiveState.bind(this);
        this.resetFilters = this.resetFilters.bind(this); // Reset 功能
        this.closeFilter = this.closeFilter.bind(this); // Close 功能
        console.log('执行了搜索')



        // $('.filter-list-item-more').on('click',function(){
        //     let box = $(this).attr('data-box');
        //     if($(`.${box}`).height() > 100){
        //         $(`.${box}`).css('height','92px');
        //         $(this).html($(this).attr('data-more'));
        //     }else{
        //         $(`.${box}`).css('height','auto');
        //         $(this).html($(this).attr('data-less'));
        //     }
        // })
        console.log(document.querySelectorAll('.filter-list-item-more'))
        document.querySelectorAll('.filter-list-item-more').forEach(function(element) {
            element.addEventListener('click', function() {
                const boxClass = this.getAttribute('data-box');
                const box = document.querySelector(`.${boxClass}`);
                const moreText = this.getAttribute('data-more');
                const lessText = this.getAttribute('data-less');

                if (box.offsetHeight > 100) {
                    box.style.height = '92px';
                    this.innerHTML = moreText;
                } else {
                    box.style.height = 'auto';
                    this.innerHTML = lessText;
                }
            });
        });

    }

    connectedCallback() {
        // 渲染过滤器内容并绑定点击事件
        this.render();

        // 监听点击事件
        this.addEventListener('click', this.handleClick);

        // 绑定 "reset" 和 "close" 按钮事件
        const resetButton = this.querySelector('.filter-reset-button');
        const closeButton = this.querySelector('.filter_close_icon');
        if (resetButton) {
            resetButton.addEventListener('click', this.resetFilters);
        }
        if (closeButton) {
            closeButton.addEventListener('click', this.closeFilter);
        }

        // 回填active状态
        this.fillActiveState();


        
    }

    render() {
        const htmlContent = this.innerHTML;
        this.innerHTML = htmlContent; // 渲染过滤器内容到普通 DOM
    }

    handleClick(event) {
        // 处理点击事件，判断是排序项还是过滤器项
        if (event.target.classList.contains('sort-filter-list-item')) {
            this.updateSort(event.target); // 如果点击的是排序项
        }

        // 确保点击的是 filter-list-items-td 元素（过滤器项）
        if (event.target.classList.contains('filter-list-items-td')) {
            const raw = event.target.getAttribute('data-value'); // 获取 data-value
            const [key, value] = raw.split('=');
            this.updateURL(key, value);
        }
    }

    updateSort(sortItem) {
        const sortValue = sortItem.getAttribute('data-value');

        // 更新 URL 中的排序参数
        const url = new URL(window.location);
        const params = url.searchParams;

        // 更新或设置排序参数
        params.set('sort_by', sortValue);

        // 更新 URL 并刷新页面
        url.search = params.toString();
        window.location.href = url.toString();
    }

    updateURL(param, value) {
        const url = new URL(window.location);
        const params = url.searchParams;

        // 如果该参数已经存在且值相同，删除该值
        if (params.has(param)) {
            const currentValues = params.getAll(param);
            if (currentValues.includes(value)) {
                // 删除已选中的值
                const updatedValues = currentValues.filter(v => v !== value);
                params.delete(param);
                updatedValues.forEach(v => params.append(param, v));
            } else {
                // 否则添加新值
                params.append(param, value);
            }
        } else {
            // 如果参数不存在，添加该参数值
            params.append(param, value);
        }

        // 刷新页面并更新URL
        url.search = params.toString();
        window.location.href = url.toString();
    }

    fillActiveState() {
        const currentParams = new URLSearchParams(window.location.search);

        // 处理排序项的 active 状态
        const sortItems = this.querySelectorAll('.sort-filter-list-item');
        sortItems.forEach(item => {
            const sortValue = item.getAttribute('data-value');
            if (currentParams.get('sort_by') === sortValue) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        // 处理过滤器项的 active 状态
        const filterItems = this.querySelectorAll('.filter-list-items-td');
        filterItems.forEach(item => {
            const raw = item.getAttribute('data-value');
            const [key, value] = raw.split('=');
            const values = currentParams.getAll(key);
            if (values.includes(value)) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    resetFilters() {
        // 清除 URL 中的所有查询参数
        const url = new URL(window.location);
        url.search = ''; // 清空查询参数

        // 刷新页面并清空所有过滤器参数
        window.location.href = url.toString(); // 直接跳转到无过滤器参数的 URL，刷新页面
    }

    closeFilter() {
        $(this).hide().removeClass('collection-filter-pupop-sort');
    }
}

// 定义自定义元素
customElements.define('collection-filter', collectionFilter);